module.exports = __webpack_public_path__ + "workspace/static/img/tenantMgmtSix.cc9c6c2.png";